import type { TableDensity } from "@/ds";
import type { ObrasColumnKey } from "../../types-obras-lista";
import { ACTION_COLUMN_WIDTH, COLUMN_WIDTHS, MOBILE_OBRA_WIDTH } from "./obras-table.constants";

// Com `tableLayout: fixed` toda coluna precisa de largura em `COLUMN_WIDTHS` (ou `ACTION_COLUMN_WIDTH`): sem ela a coluna
// fica com 0 e some. Coluna nova da Lista = largura nova aqui.
export function columnWidth(key: ObrasColumnKey, density: TableDensity, isMobile: boolean): string {
  if (key === "detalhamento") return ACTION_COLUMN_WIDTH[density];
  if (isMobile && key === "id") return MOBILE_OBRA_WIDTH;
  return COLUMN_WIDTHS[density][key] ?? "0rem";
}
